document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-zyn-video]');
  if (!button) return;
  const video = button.parentElement.querySelector('video');
  if (!video) return;
  video.src = button.dataset.zynVideo;
  video.hidden = false;
  button.hidden = true;
  video.play().catch(function () { video.focus(); });
});

document.addEventListener('click', function (event) {
 const buy=event.target.closest('[data-zyn-buy]');
 if(buy){const target=document.getElementById(buy.dataset.zynBuy);if(target)target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
 const thumb=event.target.closest('.th[data-full]');
 if(thumb){const root=thumb.closest('[id^="zyc-"]');if(!root)return;const main=root.querySelector('.main img');if(main){main.removeAttribute('srcset');main.src=thumb.dataset.full;main.alt=thumb.dataset.alt||'';}root.querySelectorAll('.th').forEach(function(item){item.classList.toggle('on',item===thumb);item.setAttribute('aria-pressed',String(item===thumb));});}
});
document.querySelectorAll('[data-zyn-pack-image]').forEach(function(wrap){
 function refresh(){wrap.querySelectorAll('img.kaching-bundles__bar-image').forEach(function(img){if(img.getAttribute('src')!==wrap.dataset.zynPackImage){img.removeAttribute('srcset');img.src=wrap.dataset.zynPackImage;img.alt='Zynaero melatonin-free sleep gummies';}});}
 refresh();new MutationObserver(refresh).observe(wrap,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
});

// Keep footer links compact on phones and expanded on larger screens.
(() => {
  const groups = document.querySelectorAll('#zft .zft-group');
  const mobile = window.matchMedia('(max-width:760px)');
  const sync = () => groups.forEach(group => { group.open = !mobile.matches; });
  sync();
  mobile.addEventListener('change', sync);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('#zhdr .zyn-mobile[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
})();
